import { UserCard, UserAddress } from "@providers/profile/ProfileProvider.model";
import { StateSchema, AddressValues } from "../address/Address.model";
import { BillingState } from "../subscription/Subscription.model";

export const initialCardState = {
  editing: false,
  error: "",
  secret: null,
};

export interface CardState {
  editing: boolean;
  error: string;
  secret: string | null;
}

export interface CreditCardProps {
  card: UserCard;
  showAddress?: boolean;
  states: Array<StateSchema>;
  dispatchBilling: React.Dispatch<React.SetStateAction<BillingState>>;
}

export const cardFormInitialValues = {
  name: "",
};

export interface CardFormValues extends Partial<AddressValues> {
  name: string;
}

export interface CreditCardFormProps {
  card: UserCard;
  cardStatus: CardState;
  dispatchCardStatus: React.Dispatch<React.SetStateAction<CardState>>;
  showAddress: boolean;
  dispatchBilling: React.Dispatch<React.SetStateAction<BillingState>>;
  states: Array<StateSchema>;
  onCancel: (e: any) => void;
}
